/* XECAR · Paneles del inicio: clic para expandir (uno abierto por fila) */
if (!customElements.get('xe-panels')) {
  customElements.define(
    'xe-panels',
    class XePanels extends HTMLElement {
      connectedCallback() {
        this.panels = [...this.querySelectorAll('.xe-hp__panel')];
        this.panels.forEach((panel) => {
          const btn = panel.querySelector('.xe-hp__toggle');
          if (!btn) return;
          btn.addEventListener('click', (e) => { e.stopPropagation(); this.toggle(panel); });
          // Todo el panel es clicable (menos sus enlaces); abierto, solo el botón lo cierra
          panel.addEventListener('click', (e) => {
            if (e.target.closest('a, button')) return;
            if (!panel.classList.contains('is-open')) this.toggle(panel);
          });
        });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.querySelector('.is-open')) {
            const open = this.querySelector('.is-open');
            this.close(open);
            open.querySelector('.xe-hp__toggle')?.focus();
          }
        });
      }
      toggle(panel) {
        if (panel.classList.contains('is-open')) return this.close(panel);
        this.panels.forEach((p) => p !== panel && this.close(p));
        panel.classList.add('is-open');
        panel.querySelector('.xe-hp__toggle')?.setAttribute('aria-expanded', 'true');
        this.classList.add('has-open');
      }
      close(panel) {
        panel.classList.remove('is-open');
        panel.querySelector('.xe-hp__toggle')?.setAttribute('aria-expanded', 'false');
        if (!this.querySelector('.is-open')) this.classList.remove('has-open');
      }
    }
  );
}


/* Celular: cada fila arranca con un panel abierto y las marcas rotan solas
   hasta que la persona toca un panel */
(() => {
  const mq = window.matchMedia('(max-width: 989px)');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = () => {
    if (!mq.matches) return;
    document.querySelectorAll('xe-panels').forEach((row) => {
      if (row.dataset.xeAuto) return;
      row.dataset.xeAuto = '1';
      const panels = [...row.querySelectorAll('.xe-hp__panel')];
      if (!panels.length || !row.toggle) return;
      if (!row.querySelector('.is-open')) row.toggle(panels[0]);
      if (reduce || panels.length < 3) return;
      let timer = null, user = false;
      const next = () => {
        if (user || document.visibilityState !== 'visible') return;
        const i = panels.findIndex((p) => p.classList.contains('is-open'));
        row.toggle(panels[(i + 1) % panels.length]);
      };
      let armed = false;
      addEventListener('scroll', () => { armed = true; }, { once: true, passive: true });
      const start = () => { if (!timer && !user) timer = setInterval(() => { if (armed) next(); }, 4500); };
      const stop = () => { clearInterval(timer); timer = null; };
      row.addEventListener('pointerdown', () => { user = true; stop(); }, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver((e) => (e[0].isIntersecting ? start() : stop()), { threshold: .5 }).observe(row);
      else start();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  mq.addEventListener?.('change', init);
})();
